import React from 'react';

import { Header } from '@tanstack/react-table';

import { Tooltip } from '../Tooltip';

import { useColumnResize } from './useColumnResize';

interface ColumnResizeHandleProps<TData> {
    header: Header<TData, unknown>;
}

export const ColumnResizeHandle = <TData,>({
    header
}: ColumnResizeHandleProps<TData>) => {
    const { isVisible, handleMouseEnter, handleMouseLeave, resizeHandler } =
        useColumnResize(header);

    if (!header.column.getCanResize()) {
        return null;
    }

    return (
        <Tooltip content="Adjust column width" side="bottom">
            <div
                onMouseDown={resizeHandler}
                onTouchStart={resizeHandler}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={(e) => e.stopPropagation()}
                className="absolute right-0 top-0 h-full w-0.5 cursor-col-resize select-none touch-none"
                style={{
                    background: 'var(--tailwind-colors-indigo-600, #4F46E5)',
                    boxShadow: '0 0 2px 0.5px var(--tailwind-colors-indigo-300, #A5B4FC)',
                    filter: 'blur(0.1px)',
                    opacity: isVisible ? 1 : 0,
                    transition: 'opacity 0.2s ease'
                }}
            />
        </Tooltip>
    );
};

